<template>
  <div class="upload-component">
    <div class="file-upload" v-if="accept === '*'">
      <a-upload
        :disabled="disabled"
        :action="uploadPartyFile"
        :file-list="fileList"
        :remove="handleRemove"
        :data="{ type: 0, biz }"
        :before-upload="beforeUpload"
        :headers="{ Authorization: token }"
        @change="handleChange"
      >
        <a-button :disabled="disabled">
          <a-icon type="upload" />
          {{ $t('选择文件') }}
        </a-button>
      </a-upload>
    </div>
    <template v-else>
      <div class="upload-image-list">
        <draggable
          class="syllable_ul"
          element="ul"
          :list="fileList"
          :options="{ group: 'title', animation: 150 }"
          :no-transition-on-drag="true"
        >
          <transition-group
            type="transition"
            class="flex flex-wrap"
            :name="!drag ? 'syll_li' : null"
            :css="true"
          >
            <div class="upload-image-item" v-for="(item, index) in fileList" :key="item.uid">
              <a-icon @click="removeCoupon(index)" class="close" type="close" />
              <a-spin
                :spinning="
                  !(item.url || (item.response && item.response.result && item.response.result.url))
                "
              >
                <div class="upload-preview" @click="handlePreview(getFileUrl(item))">
                  <img
                    v-if="!isVideoUrl(getFileUrl(item))"
                    :src="getFileUrl(item)"
                    alt="img"
                    class="upload-image"
                  />
                  <template v-else>
                    <img
                      :src="videoPosterMap[getFileUrl(item)] || videoPlaceholderPoster"
                      alt="video"
                      class="upload-image"
                      @load="ensureVideoPoster(getFileUrl(item))"
                    />
                    <div class="video-play-badge">
                      <a-icon type="play-circle" theme="filled" />
                    </div>
                  </template>
                </div>
              </a-spin>
            </div>
          </transition-group>
        </draggable>
      </div>
      <a-upload
        v-show="fileList.length < multiple"
        :action="uploadPartyFile"
        :multiple="true"
        :accept="accept"
        list-type="picture-card"
        :file-list="fileList"
        :data="{ type: 1, biz }"
        :disabled="disabled"
        :showUploadList="false"
        :before-upload="beforeUpload"
        :headers="{ Authorization: token }"
        :customRequest="customRequest"
        @change="handleChange"
      >
        <a-icon type="plus" />
        <div class="ant-upload-text">Upload</div>
      </a-upload>
      <!-- <div class="tips">tip: {{ $t('图片尺寸必须在500×500到2000×2000px之间') }}</div> -->
    </template>
    <a-modal :visible="previewVisible" :footer="null" @cancel="closePreview">
      <img v-if="previewType === 'image'" alt="example" style="width: 100%" :src="previewUrl" />
      <video v-else style="width: 100%" :src="previewUrl" controls autoplay playsinline />
    </a-modal>
  </div>
</template>
<script>
import api from '@/service/api'
import Axios, { guid } from '@/service/axios'
import draggable from 'vuedraggable'
import { Spin } from 'ant-design-vue'
import { getCookie } from '@/common/cookie'
export default {
  name: 'uploadImage',
  props: {
    multiple: {
      type: Number,
      default: 1,
    },
    imageList: {
      type: Array,
      default() {
        return []
      },
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    biz: {
      type: String,
      default: '',
    },
    accept: {
      type: String,
      default: 'image/*',
    },
  },
  data() {
    return {
      drag: false,
      previewVisible: false,
      previewType: 'image',
      previewUrl: '',
      fileList: [],
      videoPosterMap: {},
      videoPlaceholderPoster:
        'data:image/svg+xml;charset=UTF-8,' +
        encodeURIComponent(
          `<svg xmlns="http://www.w3.org/2000/svg" width="200" height="200" viewBox="0 0 200 200">
            <defs>
              <linearGradient id="g" x1="0" y1="0" x2="1" y2="1">
                <stop offset="0" stop-color="#1f2937"/>
                <stop offset="1" stop-color="#0b1220"/>
              </linearGradient>
            </defs>
            <rect width="200" height="200" rx="16" fill="url(#g)"/>
            <rect x="16" y="16" width="168" height="168" rx="12" fill="rgba(255,255,255,0.06)"/>
            <circle cx="100" cy="105" r="34" fill="rgba(255,255,255,0.18)"/>
            <polygon points="94,88 94,122 124,105" fill="rgba(255,255,255,0.92)"/>
            <text x="24" y="44" fill="rgba(255,255,255,0.75)" font-size="18" font-family="Arial, sans-serif">VIDEO</text>
          </svg>`
        ),
    }
  },
  computed: {
    uploadPartyFile() {
      return api.ossfileUpload + '?requestId=' + guid()
    },
    token() {
      return getCookie('d_session_id')
    },
  },
  watch: {
    imageList: {
      handler(newVal) {
        this.fileList = newVal
        this.$nextTick(() => this.preloadVideoPosters())
      },
      deep: true,
    },
  },
  components: {
    draggable,
    'a-spin': Spin,
  },
  mounted() {
    this.fileList = [...this.imageList]
    this.$nextTick(() => this.preloadVideoPosters())
  },
  methods: {
    getFileUrl(item) {
      return item?.url || (item?.response && item.response.result && item.response.result.url) || ''
    },
    isVideoUrl(url) {
      if (!url) return false
      const clean = String(url).split('?')[0].split('#')[0].toLowerCase()
      return (
        clean.endsWith('.mp4') ||
        clean.endsWith('.webm') ||
        clean.endsWith('.mov') ||
        clean.endsWith('.m4v') ||
        clean.endsWith('.avi') ||
        clean.endsWith('.mkv')
      )
    },
    preloadVideoPosters() {
      ;(this.fileList || []).forEach((item) => {
        const url = this.getFileUrl(item)
        if (this.isVideoUrl(url)) this.ensureVideoPoster(url)
      })
    },
    ensureVideoPoster(url) {
      if (!url || this.videoPosterMap[url] || this.videoPosterMap[url] === null) return
      // 标记为处理中，避免重复触发
      this.$set(this.videoPosterMap, url, null)
      this.captureVideoFirstFrame(url)
        .then((dataUrl) => {
          if (dataUrl) this.$set(this.videoPosterMap, url, dataUrl)
        })
        .catch(() => {
          // 跨域/解码失败等，保持 null 走占位图
          this.$set(this.videoPosterMap, url, null)
        })
    },
    captureVideoFirstFrame(url) {
      return new Promise((resolve, reject) => {
        const video = document.createElement('video')
        video.crossOrigin = 'anonymous'
        video.muted = true
        video.playsInline = true
        video.preload = 'auto'
        video.src = url

        const cleanup = () => {
          video.removeAttribute('src')
          video.load()
        }

        video.addEventListener(
          'error',
          () => {
            cleanup()
            reject(new Error('video load error'))
          },
          { once: true }
        )

        video.addEventListener(
          'loadeddata',
          () => {
            // 有些视频首帧是黑的，轻微 seek 一下
            const targetTime = Math.min(0.1, video.duration || 0.1)
            try {
              video.currentTime = targetTime
            } catch (e) {
              // ignore
            }
          },
          { once: true }
        )

        video.addEventListener(
          'seeked',
          () => {
            try {
              const canvas = document.createElement('canvas')
              canvas.width = video.videoWidth || 200
              canvas.height = video.videoHeight || 200
              const ctx = canvas.getContext('2d')
              ctx.drawImage(video, 0, 0, canvas.width, canvas.height)
              const dataUrl = canvas.toDataURL('image/jpeg', 0.8)
              cleanup()
              resolve(dataUrl)
            } catch (e) {
              cleanup()
              reject(e)
            }
          },
          { once: true }
        )
      })
    },
    async uploadToOSS(file) {
      const pre = await Axios.post(api.filePreUpload, {
        file_name: file.name,
        appCode: 'GOODS',
        'Content-Type': file.type,
      })

      const preData = pre?.result || pre?.data || pre || {}
      const uploadUrl = preData.upload_url || preData.uploadUrl
      const imageUrl = preData.image_url || preData.imageUrl || preData.url
      const ossId = preData.ossId || preData.partyFileId || preData.fileId

      if (!uploadUrl) throw new Error('missing upload_url')

      await fetch(uploadUrl, {
        method: 'PUT',
        body: file,
        headers: {
          'Content-Type': file.type,
        },
      })

      return {
        url: imageUrl,
        partyFileId: preData.partyFileId || ossId,
        ossId,
      }
    },
    async customRequest(options) {
      const { file, onError, onSuccess, onProgress } = options || {}
      try {
        onProgress && onProgress({ percent: 10 })
        const res = await this.uploadToOSS(file)
        onProgress && onProgress({ percent: 100 })
        // 兼容现有 handleChange 对 response.result.url / partyFileId 的依赖
        onSuccess &&
          onSuccess({
            success: true,
            result: {
              url: res.url,
              partyFileId: res.partyFileId,
              ossId: res.ossId,
            },
          })
      } catch (e) {
        onError && onError(e)
      }
    },
    handleChange({ file, fileList }) {
      this.fileList = fileList
      if (file) {
        this.$nextTick(() => {
          if (file.response) {
            this.fileList.forEach((item) => {
              if (item.response && item.response.result) {
                this.$set(item, 'url', item.response.result.url)
                this.$set(item, 'partyFileId', item.response.result.partyFileId)
              }
            })
            this.$nextTick(() => {
              this.$emit('update:imageList', this.fileList)
            })
            this.$nextTick(() => {
              this.$emit('changeList', 'speed')
            })
          }
        })
      }
    },
    beforeUpload(file) {
      if (this.accept === '*') return true
      const isImage = file.type && file.type.startsWith('image/')
      const isVideo = file.type && file.type.startsWith('video/')
      const allowImage = this.accept.includes('image')
      const allowVideo = this.accept.includes('video')

      if (isImage && allowImage) {
        // const isSize = this.isSize(file)
        // return isSize
        return true
      }
      if (isVideo && allowVideo) {
        return true
      }

      this.$message.error(this.$t(allowVideo ? '请上传图片或视频文件' : '请上传图片文件'))
      return false
    },
    //检测尺寸
    isSize(file) {
      let img
      return new Promise((resolve, reject) => {
        //min 500x500 max 2000x2000
        let _URL = window.URL || window.webkitURL
        img = new Image()
        img.onload = function () {
          let valid =
            img.width >= 500 && img.width <= 2000 && img.height >= 500 && img.height <= 2000
          valid ? resolve() : reject()
        }
        img.src = _URL.createObjectURL(file)
      }).then(
        () => {
          return file
        },
        () => {
          this.$error(
            `${file.name}图片尺寸（${img.width}x${img.height}）不符合要求，请修改后重新上传！`
          )
          return Promise.reject()
        }
      )
    },
    removeCoupon(index) {
      if (this.disabled) return
      this.fileList.splice(index, 1)
      this.$nextTick(() => {
        this.$emit('update:imageList', this.fileList)
      })
    },
    handlePreview(url) {
      this.previewType = this.isVideoUrl(url) ? 'video' : 'image'
      this.previewUrl = url
      this.previewVisible = true
    },
    closePreview() {
      this.previewVisible = false
      this.previewUrl = ''
      this.previewType = 'image'
    },
    handleRemove(file) {
      const index = this.fileList.indexOf(file)
      const newFileList = this.fileList.slice()
      newFileList.splice(index, 1)
      this.fileList = newFileList
    },
  },
}
</script>
<style lang="scss" scoped>
ul {
  padding: 0;
}
// 因为我们用的ant的组件的class，会有些默认样式要去掉，如果样式是你自己写的，那就不需要这块了
.ant-upload-list {
  display: block !important;
}
.upload-image-list {
  .upload-image-item {
    width: 100px;
    height: 100px;
    position: relative;
    margin-right: 14px;
    margin-bottom: 10px;
    .close {
      position: absolute;
      top: 4px;
      right: 4px;
      font-size: 16px;
      z-index: 999;
      opacity: 1;
    }
    .upload-image {
      width: 100px;
      height: 100px;
    }
    .upload-preview {
      width: 100px;
      height: 100px;
      position: relative;
      cursor: pointer;
    }
    .video-play-badge {
      position: absolute;
      inset: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 34px;
      color: rgba(255, 255, 255, 0.9);
      text-shadow: 0 2px 10px rgba(0, 0, 0, 0.35);
      pointer-events: none;
    }
  }
}
.tips {
  font-size: 12px;
  color: #909399;
  line-height: 12px;
  margin-right: 20px;
  margin-bottom: 10px;
}
.flex-wrap {
  flex-wrap: wrap;
}
</style>
